import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { useOpenVoiceToVoice } from '#pplx/frontend/apps/ask/ask-input/ask-input-voice/hooks/useOpenVoiceToVoice.js';
import { useWebVoiceAction } from '#pplx/frontend/apps/ask/multimodal/voice/launcher/useWebVoiceAction.js';
import { Size } from '#pplx/frontend/components/types/types.js';
import React from 'react';
export const VoiceToVoiceButton = React.memo(function VoiceToVoiceButton({ pill = false, onClick: onClickProp }) {
    const defaultOnClick = useOpenVoiceToVoice();
    const action = useWebVoiceAction({ fallback: onClickProp ?? defaultOnClick });
    return (_jsx(Button, { onClick: action.onPress, size: Size.small, icon: action.icon, variant: "primary", "aria-label": action.label, rounded: pill }));
});
//# sourceMappingURL=VoiceToVoiceButton.js.map